module.exports = __webpack_public_path__ + "files/ef1d321866c50d149ccfa75c793b2f6b.svg";